import { styled } from '@/lib/utils'

export const Container = styled('div')('h-[calc(100vh-110px)] mb-25')

export const LogsWithSidebar = styled('div')(
  'flex border rounded-lg overflow-hidden shadow-sm h-full'
)

export const LogsContent = styled('div')('flex-1 min-w-0 min-h-0 flex flex-col')
